import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { ISupplierResource } from '~/types/supplier/models'
import type { TEntityId } from '~/types/models'

const apiEntityPath = '/api/supplierresources'

export async function getSupplierResources({ apiPath = apiEntityPath } = {}) {
  const callingMn = getSupplierResources.name
  return httpGet<ISupplierResource[]>({ callingMn, apiPath })
}

// export async function getSupplierResourcesPreProcessed({
//   apiPath = apiEntityPath,
// } = {}) {
//   const callingMn = getSupplierResources.name
//   const rawSupplierResources = await httpGet<ISupplierResource[]>({
//     callingMn,
//     apiPath,
//   })
//   return rawSupplierResources.map((rawSupplierResource) => {
//     return rawSupplierResource.address === undefined
//       ? rawSupplierResource
//       : Object.assign(
//           rawSupplierResource,
//           (rawSupplierResource.address = Address(rawSupplierResource.address))
//         )
//   })
// }

export async function createSupplierResource(entity: ISupplierResource) {
  const callingMn = createSupplierResource.name
  const apiPath = apiEntityPath
  return httpPost<ISupplierResource>({ callingMn, apiPath, entity })
}

export async function updateSupplierResource(
  entityData: Partial<ISupplierResource>,
  id: TEntityId
) {
  const callingMn = updateSupplierResource.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialISupplierResource = Partial<ISupplierResource>
  return httpPatchMerge<TPartialISupplierResource>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteSupplierResource(entityData: ISupplierResource) {
  const callingMn = deleteSupplierResource.name
  const apiPath = apiEntityPath
  return httpDelete<ISupplierResource>({
    callingMn,
    apiPath,
    entityData,
  })
}
